<template>
    <div class="booking">
        <h1>Varaa aika</h1>
        <h2>Kumpaan toimipisteeseen haluat varata ajan?</h2>
        <div class="buttons">
            <a href="https://booksalon.fi/fiilis" class="btn btn-primary" target="_blank">Espoo</a>
            <a href="https://vello.fi/koliklinikka/" class="btn btn-primary" target="_blank">Lohja</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BookingPage'
    };
</script>

<style scoped>
    .booking {
        padding: 20px;
        text-align: center;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .btn {
        padding: 10px 20px;
        margin-top: 20px;
        font-size: 1.5rem;
        text-align: center;
        text-decoration: none;
        background-color: #d1aca5;
        color: black;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .btn-primary {
        background-color: #E2CFC9;
    }

        .btn-primary:hover {
            background-color: #bc9a94;
        }
</style>
